import * as React from 'react';
import { Field } from 'redux-form';

import type { QuantityUnitType } from '@acceligentllc/shared/enums/quantityUnit';
import * as ReportBlockFieldEnum from '@acceligentllc/shared/enums/reportBlockField';

import Input from 'af-fields/Input';

import fieldHoc from '../Shared/fieldHoc';

interface OwnProps {
	disabled: boolean;
	formName: string;
	name: string;
	hasTooltip: boolean;
	tooltipMessage?: React.ComponentProps<typeof Input>['tooltipMessage'];
	unit: Nullable<QuantityUnitType>;
	valueType: ReportBlockFieldEnum.ValueType;
	maxDigits?: Nullable<number>;
	onFocus?: () => void;
	onBlur: () => void;
	onChange: () => void;
}

type Props = OwnProps;

const InputField: React.FC<Props> = (props) => {
	const {
		disabled,
		formName,
		name,
		hasTooltip,
		tooltipMessage,
		unit,
		valueType,
		onBlur,
		onFocus,
		onChange,
		maxDigits,
	} = props;

	return (
		<Field
			addonAfter={unit}
			component={Input}
			decimalPoints={4}
			disabled={disabled}
			label={name}
			maxIntegerDigits={maxDigits} // Only available on number and compound
			name={formName}
			onBlur={onBlur}
			onChange={onChange}
			onFocus={onFocus}
			placeholder={name}
			tooltipMessage={hasTooltip ? tooltipMessage : null}
			type={valueType === ReportBlockFieldEnum.ValueType.NUMBER ? 'number' : valueType}
		/>
	);
};

export default fieldHoc(React.memo(InputField));
